import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { getProgressByCurriculum } from './api';
import { IResourceFile } from '../../ResourcesSlice';

interface ISubTopicForProgress {
  _id: string;
  completion: number;
  resourcePart?: number;
  quizPart?: number;
  practicePart?: number;
}

interface ITopicForProgress {
  _id: string;
  subTopics: ISubTopicForProgress[];
}

interface ILastActivitySubTopic {
  _id: string;
  name: string;
  topic: { _id: string; name: string };
  resources?: Array<IResourceFile>;
}

export interface ISubjectForProgress {
  subject: string;
  subjectCode: string;
  subjectLevel: string;
  lastActivityAt?: string;
  lastActivitySubTopic?: ILastActivitySubTopic;
  topics: ITopicForProgress[];
  completedSubTopics?: number;
}

export interface IProgress {
  userId: string;
  subjects: ISubjectForProgress[];
  curriculumId: { name: string };
}

export interface IProgressState {
  status: 'idle' | 'loading' | 'rejected';
  progress: IProgress;
}

const initialState: IProgressState = {
  status: 'idle',
  progress: {
    curriculumId: { name: '' },
    userId: '',
    subjects: [],
  },
};

export const ProgressSliceV2 = createSlice({
  name: 'progressV2',
  initialState,
  reducers: {
    resetProgress: (state) => {
      state.progress = { ...initialState.progress };
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Curriculum Progress
      .addCase(getProgressByCurriculum.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getProgressByCurriculum.fulfilled, (state, action) => {
        state.status = 'idle';

        if (action.payload) {
          state.progress = action.payload;
        }
      })
      .addCase(getProgressByCurriculum.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getProgressV2State = (state: RootState): RootState['progressV2'] =>
  state.progressV2;

export const { resetProgress } = ProgressSliceV2.actions;

export * from './api';
export default ProgressSliceV2.reducer;
